import styled from 'styled-components'

export const Path = styled.path`    
    stroke: #7ACDD4!important;
`
